import Ajax from 'js/utils/ajax/ajax';

export const getProcessedInvoiceBatchesForShop = (shopId) =>
  Ajax.get(`/invoices/v1/invoicebatches/processed/shops/${shopId}`);
